<template>
  <div class="section">
    <slot name="header">
      <h3 class="section-title">{{ customer.id > -1 ? `${customerData.name} szerkesztése` : 'Új ügyfél' }}</h3>
    </slot>
    <div class="section-content">
      <div class="section">
        <div class="section-title">
          <h4>Adatok</h4>
        </div>
        <div class="section-content">
          <customer-editor v-model="customerData" :errors="errors" @validated="$e => validCustomer = $e"></customer-editor>
          <b-form-group
            :state="errors$state.length > 0 ? false : null"
            :invalid-feedback="errors$state"
          >
            <label for="state">Státusz</label>
            <b-form-select
              id="state"
              v-model="customerData.state"
              :options="customerStates"
              :state="errors$state.length > 0 ? false : true"
            />
          </b-form-group>
          <b-form-group
            :state="errors$price_discount.length > 0 ? false : null"
            :invalid-feedback="errors$price_discount"
          >
            <label for="price_discount">Kedvezmény</label>
            <b-input-group>
              <b-form-input
                id="price_discount"
                v-model="priceDiscount"
                type="number"
                min="0"
                max="100"
                :state="errors$price_discount.length > 0 ? false : priceDiscountState"
              />
              <b-input-group-append>
                <b-input-group-text>%</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <slot name="afterCustomer">
          <b-form-group
            class="text-right mb-5"
          >
            <div class="row">
              <div class="col-6 text-left">
              </div>
              <div class="col-6">
                <b-button
                  :disabled="saving || !isValid || saved"
                  variant="success"
                  @click="save"
                >
                  <span>Mentés</span>
                  <b-spinner
                    v-show="saving"
                    variant="light"
                    label="Mentés"
                    small
                  />
                </b-button>
              </div>
            </div>
          </b-form-group>
        </slot>
      </div>
      <div class="section" v-if="customerData.id > 0">
        <div class="d-flex section-title">
          <h4>Vásárlások</h4>
          <b-button-group class="ml-auto" size="sm">
            <b-button variant="success" size="sm" @click="showPurchaseModal = true">Csomag vásárlása</b-button>
          </b-button-group>
        </div>
        <div class="section-content">
          <purchases-table :customer-id="customerData.id" />
        </div>

        <purchase-modal ref="purchase" :customer-id="customerData.id" :customer-discount="customerData.price_discount" :show.sync="showPurchaseModal"></purchase-modal>
      </div>

      <div class="section" v-if="customerData.id > 0">
        <div class="d-flex section-title">
          <h4>Készletek</h4>
        </div>
        <div class="section-content">
          <pools-table :customer-id="customerData.id" />
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<style>
</style>
<script>
import VueTagsInput from '@johmun/vue-tags-input'
import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'
import AddressInput from '../common/AddressInput'
import emptyCustomer from './_customer'
import CustomerEditor from './CustomerEditor'

export default {
  mixins: [
    FormValidation(['state', 'price_discount']),
    ErrorHandler()
  ],
  components: {
    'customer-editor': CustomerEditor,
    'tags-input': VueTagsInput,
    'address-input': AddressInput
  },
  props: {
    customer: {
      type: Object,
      default: () => (emptyCustomer)
    },
  },
  data() {
    return {
      showPurchaseModal: false,
      customerStates: [{
        value: 'active',
        text: 'Aktív'
      }, {
        value: 'inactive',
        text: 'Inaktív'
      }, {
        value: 'deleted',
        text: 'Törlés alatt'
      }],
      customerData: emptyCustomer,
      saving: false,
      saved: false,
      errors: {},
      validCustomer: true,
      message: '',
    }
  },
  computed: {
    priceDiscount: {
      get() {
        return Math.round(this.customerData.price_discount * 100)
      },
      set(percent) {
        this.customerData.price_discount = percent / 100
      }
    },
    priceDiscountState() {
      return this.priceDiscount >= 0 && this.priceDiscount <= 100
    },
    isValid() {
      return this.validCustomer && this.priceDiscountState
    }
  },
  watch: {
    customerData: {
      deep: true,
      handler(data) {
        this.saved = false
      }
    }
  },
  mounted() {
    _.forEach(this.customer, (value, name) => {
      this.customerData[name] = value
    })

    this.$nextTick(() => {
      this.saved = this.customer.id !== -1
    })
  },
  methods: {
    tagsChanged(tags) {
      this.emails = _.map(tags, tag => tag.text)
    },
    save() {
      if(!this.isValid) {
        return
      }

      this.saving = true
      this.clearErrors()
      this.errors = {}

      const path = this.customerData.id > -1 ? this.$url('api.customers.update', this.customerData.id) : this.$url('api.customers.store')
      const method = this.customerData.id > -1 ? 'patch' : 'post'

      this.$http[method](path, this.customerData)
        .then((response) => {
          var data = response.data

          if(data.customer) {
            this.customerData.name = data.customer.name
            this.customerData.id = data.customer.id

            this.showMessage('Sikeres mentés')

          } else {
            this.handleError('Hiba történt a mentés közben')
          }

          this.$emit('update:customer', data.customer)
        })
        .catch((err) => {
          this.errors = this.handleErrors(err)
        })
        .finally(() => {
          this.saving = false
          this.saved = true
        })
    },
    showMessage(message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: variant === 'success' ? 'Siker' : 'Figyelem',
        variant,
        autoHideDelay: 2000,
        appendToast: true
      })
    }
  },
}
</script>